import { PasswordInput } from '@mantine/core';
import { useFocusWithin } from '@mantine/hooks';
import cx from 'clsx';
import { FC, memo } from 'react';
import defaultStyles from 'src/components/Form/styles.default.module.css';
import { Icon } from 'src/components/Icon';
import { useFormContext } from 'src/form';

import styles from './styles/styles.module.css';

type Props = {
  name: string;
  label: string;
  placeholder: string;
};

export const InputPassword: FC<Props> = memo((props) => {
  const { ref, focused } = useFocusWithin();
  const form = useFormContext();

  const formProps = form.getInputProps(props.name);

  return (
    <PasswordInput
      ref={ref}
      classNames={{
        innerInput: defaultStyles.innerInput,
        input: defaultStyles.input,
        label: defaultStyles.label,
        root: cx({
          [defaultStyles.root]: true,
          [defaultStyles.rootFocused]: focused,
        }),
        section: styles.section,
        visibilityToggle: styles.toggle,
      }}
      withAsterisk={false}
      visibilityToggleIcon={({ reveal }) => (
        <Icon
          className={cx({
            [styles.iconEye]: true,
            [styles.iconEyeActive]: reveal,
          })}
          name="visibility"
        />
      )}
      {...props}
      {...formProps}
    />
  );
});
